export default __webpack_public_path__ + "static/media/editing_journey.b0f2a5a0.png";